export const HOME = "/"
export const LOGIN = "/login"
export const MANAGE_PROCUREMENTS = "/manageprocurements"
export const ADD_PROCUREMENT_DIALOG = "/addprocurementdialog"
export const EDIT_PROCUREMENT_DIALOG = "/editprocurementdialog/"
export const DELETE_PROCUREMENT_DIALOG = "/deleteprocurementdialog/"



// WEBPACK FOOTER //
// ./src/routes.js